kv.controller('ProfileCtrl', function ($scope, $element, $attrs, $injector, resource, $sce) {

	var vm = new baseCtrl($scope, $element, $attrs, $injector);
	vm.primaryKey = 'user_id';
	vm.entity = 'user';
	var REST = resource.init(vm.entity);

	let url_segments = window.location.pathname.split('/'); // ['/','profile']
	let page_entity_id = url_segments[2] || null;          // safe fallback
	let activeTab = new URLSearchParams(window.location.search).get('tab'); // 'twofa'

	KApp.block($element);

    /**
     * Disable/Enable the UI when 2FA is required
     *
     * @param disable
     */
    function set2FADisabled(disable) {
        // find element id k_aside_menu_wrapper
        let asideMenu = document.getElementById('k_aside_menu');
        if (disable) {
            asideMenu.classList.add('disabled');
        } else {
            asideMenu.classList.remove('disabled');
        }
    }

// --- Wait for UI (so menu exists) ---
	function waitForUIAndToggle(disable) {
		const checkInterval = setInterval(() => {
			const menuReady = document.querySelector('#k_aside_menu .k-menu__item > a');
			if (menuReady) {
				clearInterval(checkInterval);
				set2FADisabled(disable);
			}
		}, 150);
		setTimeout(() => clearInterval(checkInterval), 5000);
	}

// --- Detect if tab=twofa in URL ---

	function getData() {
		REST.get({
			url:"profile"
		}).then(response => {
			KApp.unblock($element);
			if (response.status == false) return vm.showErrorMessages(response);
			vm.dataHasLoaded = true;
			vm.data = response;

            // check svg as html
            if (response.two_factor_qr) {
                vm.data.two_factor_qr = $sce.trustAsHtml(response.two_factor_qr);
            }
			vm.data.croppedAvatar = "";
			vm.data.originalAvatar = "";
		}).finally(() => {
			if (activeTab === 'twofa') {
				if (!vm.data.two_factor_confirmed_at) {
					vm.forceTwoFA = true;
					waitForUIAndToggle(true);
				} else {
					vm.forceTwoFA = false;
					waitForUIAndToggle(false);
				}
			}
		});
	}

	vm.data = getData();

	// used for displaying the error message
	$scope.passwordError = false;
	$scope.validationError = false;

	vm.validateSomeInputs = function () {
		vm.custom_errors = null;
		vm.has_error = false;

		if(emailIsValid(vm.data.email) === false){
			$('[ng-model="vm.data.email"] .select2-selection--single').css("border", "1px solid red");
			if (!vm.custom_errors) vm.custom_errors = [];
			vm.custom_errors.push(vm.trans('LANG.EMAIL_IS_INVALID'));
			vm.has_error = true;
		} else {
			$('[ng-model="vm.data.email"] .select2-selection--single').css("border", "1px solid #c2cad8");
		}

		if(vm.has_error){
			$('.custom_error_messages').css('display', 'block');
		} else {
			$('.custom_error_messages').css('display', 'none');
			vm.save();
		}

	};


	vm.resetPassword = function () {
		let postData = angular.copy(vm.data);
		let rest = vm.getInjection('resource').init('user');
		// expression for password to contain a capital letter
		var containsCapitalLetter = new RegExp("^(?=.*[A-Z])");
		//expression for password to contain a number
		var containsNumber = new RegExp("(?=.*[0-9])");
		error = false;
		old_password_error = false;

		// if tenant password policy is FORCE_STRONG PASSWORD
		if (postData.new_password) {
			if (vm.data.tenant.tenant_ext.password_policy == "FORCE_STRONG_PASSWORD") {
				// if one of the passwords are set...
				if (postData.new_password || postData.confirm_password) {
					// ...verify password length
					lengthError = !(postData.new_password && (postData.new_password.length >= 8));

					// ...verify password to contain a capital letter
					if (containsCapitalLetter.test(postData.new_password)) {
						containsCapitalLetterError = false;
					} else {
						containsCapitalLetterError = true;
					}

					// ...verify password to contain a number
					if (containsNumber.test(postData.new_password)) {
						containsNumberError = false;
					} else {
						containsNumberError = true;
					}

					// if password ok (no error from above), verify if password is equal to confirm_password
					if (!lengthError && !containsCapitalLetterError && !containsNumberError) {
						if (postData.new_password == postData.confirm_password) {
							error = false;
							$('[ng-model="vm.data.new_password"] input, [ng-model="vm.data.new_password"]').css("border", "1px solid #c2cad8");
							$('[ng-model="vm.data.confirm_password"] input, [ng-model="vm.data.confirm_password"]').css("border", "1px solid #c2cad8");
						} else {
							error = true;
							$scope.validationError = true;
							$('[ng-model="vm.data.new_password"] input, [ng-model="vm.data.new_password"]').css("border", "1px solid red");
							$('[ng-model="vm.data.confirm_password"] input, [ng-model="vm.data.confirm_password"]').css("border", "1px solid red");
						}
						if (!postData.old_password) {
							error = true;
							$scope.validationError = true;
							$('[ng-model="vm.data.old_password"] input, [ng-model="vm.data.old_password"]').css("border", "1px solid red");
						}
						$scope.passwordError = false;
					} else {
						error = true;
						$scope.passwordError = true;
						$('[ng-model="vm.data.new_password"] input, [ng-model="vm.data.new_password"]').css("border", "1px solid red");
					}
				}
				// if tenant password policy is STANDARD, just verify the two passwords
			} else {
				if (postData.new_password == postData.confirm_password) {
					error = false;
					$('[ng-model="vm.data.new_password"] input, [ng-model="vm.data.new_password"]').css("border", "1px solid #c2cad8");
					$('[ng-model="vm.data.confirm_password"] input, [ng-model="vm.data.confirm_password"]').css("border", "1px solid #c2cad8");
				} else {
					error = true;
					$scope.validationError = true;
					$('[ng-model="vm.data.new_password"] input, [ng-model="vm.data.new_password"]').css("border", "1px solid red");
					$('[ng-model="vm.data.confirm_password"] input, [ng-model="vm.data._confirm_password"]').css("border", "1px solid red");
				}
				if (!postData.old_password) {
					error = true;
					$scope.validationError = true;
					$('[ng-model="vm.data.old_password"] input, [ng-model="vm.data.old_password"]').css("border", "1px solid red");
				}
			}
		}

		// check if field was filled with data
		if (vm.data.old_password && vm.data.old_password.length) {
			old_password_error = false;
		} else {
			old_password_error = true;
		}

		// if field is not empty, make request
		if (error === false && old_password_error === false) {
			var resetPasswordData = {
				'old_password' : postData.old_password,
				'password' : postData.new_password,
			};
			rest.post({
				url: "profile/changePassword",
				id: vm.data.user_id,
				data: resetPasswordData
			}).then((response) => {
				if(response.status == true){
					toastr.success(vm.trans('LANG.OPERATION_SUCCESSFULLY'), {timeOut: 2000});
					setTimeout(function(){
						window.location.href =  window.origin + '/auth/logout';
					}, 1000);
				}else{
					vm.alert('ALERT', vm.trans(response.data.error));
				}
			});
		}
	};


    /**
     * Enable 2FA - show modal with QR code and secret
     */
    vm.enable2FA = function () {
        let rest = vm.getInjection('resource').init('user');
        rest.post({
            url: "profile/two-factor/enable",
        }).then((response) => {
            if(response.status === true){
                vm.data.two_factor_secret = response.data.two_factor_secret;
                vm.data.two_factor_qr = $sce.trustAsHtml(response.data.two_factor_qr);
             //   vm.data.two_factor_confirmed_at = response.data.two_factor_confirmed_at;
                vm.data.recovery_codes = response.data.recovery_codes;
				if(activeTab === 'twofa') {
					//set2FADisabled(false);
				}
                // $('#enable2FAModal').modal('show');
            }else{
                vm.alert('ALERT', vm.trans(response.data.error));
            }
        });
    }

    /**
     * Disable 2FA
     */
    vm.disable2FA = function () {
        let rest = vm.getInjection('resource').init('user');
		vm.confirm('Confirm', vm.trans('LANG.DISABLE_2FA_MESSAGE')).then(response => {
			if (response !== 'ok') return;
			rest.post({
				url: "profile/two-factor/disable",
			}).then((response) => {
				if(response.status === true){
					vm.data.two_factor_secret = null;
					vm.data.two_factor_qr = null;
					vm.data.two_factor_confirmed_at = null;
					vm.data.recovery_codes = null;
					if(activeTab === 'twofa') {
						set2FADisabled(true);
					}
					toastr.success(vm.trans('LANG.OPERATION_SUCCESSFULLY'), {timeOut: 2000});
				}else{
					vm.alert('ALERT', vm.trans(response.data.error));
				}
			});
		});
    }

	vm.confirm2FA = function (confirmCode) {
		let rest = vm.getInjection('resource').init('user');
		rest.post({
			url: "profile/two-factor/confirm",
			data: {
				code: confirmCode,
				target: 'fromProfile'
			}
		}).then((response) => {
			if(response.status === true){
				vm.data.two_factor_confirmed_at = response.data.confirmed_at;
				//vm.data.recovery_codes = res.data.recovery_codes;
				if(activeTab === 'twofa') {
					set2FADisabled(false);
				}
				toastr.success(response.message, {timeOut: 2000});
                // redirect to login page after 2FA setup
                setTimeout(function(){
                    window.location = '/auth/logout';
                }, 2000);
			}else{
				toastr.error(vm.trans(response.data.error));
			}
		}).catch(() => {
			toastr.error('Invalid verification code.');
		});
	}

	function emailIsValid (email) {
		return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
	}

	vm.save = function () {
		error = false;
		var postData = angular.copy(vm.data);

        // remove fields not needed in post request
		delete postData.user_user;
		delete postData.user_practice;
   //     delete postData.croppedAvatar;


		// if no error, update profile
		if (!error) {
			REST.update({
				url: 'profile',
				data: postData
			}).then(function () {
				window.location = '/profile';
			});
		}
	};

	return vm;
});
